// LWI-1413 — helpers for reasoning about shipment countries.
// Location country values in the data are inconsistent (e.g. "USA", "US",
// "CANADA", "CA"), so normalize before comparing.

// Known spellings that mean "United States".
export const US_COUNTRY_VALUES = new Set([
  "US",
  "USA",
  "U.S.A.",
  "UNITED STATES",
  "UNITED STATES OF AMERICA",
]);

/** True when the given country value represents the United States. */
export const isUsCountry = (country) =>
  US_COUNTRY_VALUES.has(String(country || "").trim().toUpperCase());

const isBlankCountry = (country) => String(country || "").trim() === "";

/**
 * True when both endpoints are in the US (a domestic shipment), false when
 * both are known and either is outside it. LWI-1753 — null when either
 * country is blank: unknown, not international. Callers that test truthiness
 * still treat null as "not provably domestic" (a Customs Invoice may be
 * needed); the derived Customs Processing stage requires exactly false.
 */
export const isDomesticUs = (fromCountry, toCountry) => {
  if (isBlankCountry(fromCountry) || isBlankCountry(toCountry)) return null;
  return isUsCountry(fromCountry) && isUsCountry(toCountry);
};
